import { Component, effect } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslocoService } from '@jsverse/transloco';
import { INPUT_TYPES } from '../../../shared/constants/input-types';
import { CustomCurrencyPipe } from '../../../shared/pipes/custom-currency-pipe';
import { SchedulingService } from '../../../core/services/scheduling.service';
import { Provider, Service, ServicesScheduling, SubService } from '../../../core/models/scheduling/services-scheduling.model';
import { VehiclesService } from '../../../core/services/vehicles.services';
import { Vehicle } from '../../../core/models/vehicles/vehicle.model';
import { CreateScheduling } from '../../../core/models/scheduling/create-scheduling.model';
import { BenefitsService } from '../../../core/services/benefits.service';
import { CurrentBenefits } from '../../../core/models/benefits/current-benefits';
import { ClaimWash } from '../../../core/models/benefits/claim-wash.model';
import { CurrentDiscounts } from '../../../core/models/benefits/current-discounts.model';
import { ClaimDiscount } from '../../../core/models/benefits/claim-discount.model';

@Component({
  selector: 'app-scheduling-form',
  standalone: false,
  templateUrl: './scheduling-form.component.html',
  styleUrl: './scheduling-form.component.scss'
})
export class SchedulingFormComponent {

  INPUT_TYPES = INPUT_TYPES;

  private currencyPipe = new CustomCurrencyPipe();

  txtBtn = '';

  get message() {
    return [
      {
        title: this.transloco.translate('schedulingForm.paymentInfoTitle'),
        content: this.transloco.translate('schedulingForm.paymentInfoContent')
      },
      {
        title: this.transloco.translate('schedulingForm.paymentProcessedTitle'),
        content: this.transloco.translate('schedulingForm.paymentProcessedContent')
      }
    ];
  }

  statusModal = 0;

  serviceSelected = '';
  subServiceSelect: string[] = [];
  plate = '';
  partner = '';
  dateBenefit: Date | null = null;
  discountSelected = '';

  listDiscounts: Record<string, string>[] = [];
  listPartners: Provider[] | null = null;
  listServices: Service[] = [];
  listSubServices: SubService[] = [];
  listVehicles: Vehicle[] = [];

  filteredServicesId: string[] = [];
  filteredSubServicesId: string[] = [];

  totalPrice = 0;

  currentServices: ServicesScheduling[] | null = null;
  currentVehicles: Vehicle[] | null = null;

  type: 'car-wash' | 'discount' | undefined = undefined;
  currentBenefits: CurrentBenefits | null = null;
  currentDiscounts: CurrentDiscounts | null = null;

  constructor(
    public messageService: MessageService,
    public ref: DynamicDialogRef,
    private schedulingService: SchedulingService,
    private benefitsService: BenefitsService,
    vehicleService: VehiclesService,
    public config: DynamicDialogConfig<{ type: 'car-wash' | 'discount' }>,
    private transloco: TranslocoService
  ) {
    this.txtBtn = this.transloco.translate('schedulingForm.continue');
    if (config.data) {
      this.type = config.data.type;
    }

    if (this.type === undefined || this.type === 'discount') {
      vehicleService.getListVehiclesAssigned().subscribe(data => {
        this.currentVehicles = data;
        this.formatByVehicles();
      });
    } else if (this.type === 'car-wash') {

    }

    effect(() => {
      if (this.type === undefined || this.type === 'discount') {
        this.currentServices = this.schedulingService.listServicesByScheduling();
        if (!this.currentServices) {
          this.schedulingService.loadServices().subscribe();
        } else {
          if (this.type === undefined)
            this.formatByProviders();
        }
      }
      else if (this.type === 'car-wash') {
        this.listPartners = this.benefitsService.listCarWashProviders();
        this.currentBenefits = this.benefitsService.currentBenefits();
        if (!this.listPartners) {
          this.benefitsService.loadCarWashProviders().subscribe();
        }
        if (!this.currentBenefits) {
          this.benefitsService.loadListBenefits().subscribe();
        } else {
          this.currentBenefits = this.benefitsService.currentBenefits();
          this.formatByVehicles();
        }
      }
      if (this.type === 'discount') {
        this.currentDiscounts = this.benefitsService.listDiscounts();
        if (!this.currentDiscounts) {
          this.benefitsService.loadListDiscounts().subscribe();
        } else {
          this.formatByDiscounts();
        }
      }
    });
  }

  optionMapperProvider = (element: Provider): { name: string; value: string } => ({
    name: element.name,
    value: String(element.userId)
  });

  optionMapperSubService = (element: SubService) => ({
    name: element.name + ' - ' + this.currencyPipe.transform(element.price) + (this.type === 'car-wash' ? ' ' + this.transloco.translate('schedulingForm.free') : ''),
    value: element.id + ''
  });

  optionMapperService = (element: Service) => ({
    name: element.name,
    value: element.id + ''
  });

  optionMapperVehicle = (element: Vehicle) => ({
    name: element.plate,
    value: element.id + ''
  });

  optionMapperDiscount = (element: Record<string, string>) => {
    const key = Object.keys(element)[0] as keyof typeof element;
    return {
      name: element[key],
      value: key
    };
  };

  searchBenefits(_event: String) {

  }

  createBenefit() {
    if (!this.plate) {
      this.messageService.add({ severity: 'error', summary: this.transloco.translate('common.error'), detail: this.transloco.translate('schedulingForm.selectValidPlate') });
      return;
    }

    if (this.type === 'discount' && !this.discountSelected) {
      this.messageService.add({ severity: 'error', summary: this.transloco.translate('common.error'), detail: this.transloco.translate('schedulingForm.selectDiscount') });
      return;
    }

    if (!this.partner || !this.serviceSelected || this.subServiceSelect.length === 0 || !this.plate || !this.dateBenefit) {
      this.messageService.add({ severity: 'error', summary: this.transloco.translate('common.error'), detail: this.transloco.translate('schedulingForm.completeAllFields') });
      return;
    }

    const benefitDate = new Date(this.dateBenefit);
    const now = new Date();
    benefitDate.setHours(0, 0, 0, 0);
    now.setHours(0, 0, 0, 0);

    if (benefitDate < now) {
      this.messageService.add({ severity: 'error', summary: this.transloco.translate('common.error'), detail: this.transloco.translate('schedulingForm.dateInPast') });
      return;
    }

    if (this.statusModal === 0) {
      this.statusModal = 1;
      if (this.type === 'car-wash') {
        this.txtBtn = this.transloco.translate('schedulingForm.confirmAppointment');
      } else {
        this.txtBtn = this.transloco.translate('schedulingForm.scheduleAndPay');
      }
    } else if (this.statusModal === 1) {
      if (this.type === 'car-wash') {
        this.claimBenefit();
      } else if (this.type === 'discount') {
        this.claimDiscount();
      } else {
        this.createScheduling();
      }
    } else {
      this.ref.close({ reload: true });
    }
  }

  getSubServiceSelected() {
    const selected = this.listSubServices.filter(
      sub => this.subServiceSelect.includes(sub.id)
    );
    return selected.map(sub => ({ name: sub.name, price: sub.price }));
  }

  formatByProviders() {
    if (this.currentServices) {
      const uniqueProvidersMap = new Map<string, Provider>();
      this.currentServices.forEach(item => {
        if (item.provider) {
          uniqueProvidersMap.set(item.provider.userId, item.provider);
        }
      });
      this.listPartners = Array.from(uniqueProvidersMap.values());
    }
  }

  formatByServices() {
    if (this.type === undefined || this.type === 'discount') {
      if (this.currentServices && this.partner && this.partner !== '') {
        const uniqueServicesMap = new Map<string, Service>();
        this.currentServices.forEach(item => {
          if (item.provider.userId === this.partner) {
            if (!uniqueServicesMap.has(item.service.id)) {
              uniqueServicesMap.set(item.service.id, item.service);
            }
          }
        });
        this.listServices = Array.from(uniqueServicesMap.values());

        if (this.filteredServicesId.length > 0 && this.type === 'discount') {
          this.listServices = this.listServices.filter(service => this.filteredServicesId.includes(service.id));
        }
      }
    } else if (this.type === 'car-wash') {
      this.selectService('car-wash');
    }
  }

  formatBySubService() {
    if (this.serviceSelected &&
      this.serviceSelected !== '' &&
      this.partner &&
      this.partner !== '') {
      if (this.type === undefined || this.type === 'discount') {
        if (this.currentServices) {
          const uniqueSubServicesMap = new Map<string, SubService>();
          this.currentServices.forEach(item => {
            if (
              item.service.id === this.serviceSelected &&
              item.provider.userId === this.partner
            ) {
              item.subServices.forEach(sub => {
                if (!uniqueSubServicesMap.has(sub.id)) {
                  uniqueSubServicesMap.set(sub.id, sub);
                }
              });
            }
          });
          this.listSubServices = Array.from(uniqueSubServicesMap.values());

          if (this.filteredSubServicesId.length > 0 && this.type === 'discount') {
            this.listSubServices = this.listSubServices.filter(subService => this.filteredSubServicesId.includes(subService.id));
          }
        }
      }
      else if (this.type === 'car-wash') {
        if (this.listPartners) {
          const uniqueSubServicesMap = new Map<string, SubService>();
          this.listPartners.forEach(partner => {
            if (partner.userId === this.partner && partner.subServices) {
              partner.subServices.forEach(element => {
                if (!uniqueSubServicesMap.has(element.id)) {
                  uniqueSubServicesMap.set(element.id, element);
                }
              });
            }
          });
          this.listSubServices = Array.from(uniqueSubServicesMap.values());
        }
      }
    }
  }

  formatByVehicles() {
    if (this.type === undefined || this.type === 'discount') {
      if (this.currentVehicles) {
        const uniqueVehiclesMap = new Map<string, Vehicle>();
        this.currentVehicles.forEach(item => {
          uniqueVehiclesMap.set(item.id, item);
        });
        this.listVehicles = Array.from(uniqueVehiclesMap.values());
      }
    }
    else if (this.type === 'car-wash') {
      if (this.currentBenefits) {
        const uniqueVehiclesMap = new Map<string, Vehicle>();
        this.currentBenefits.benefits.forEach(item => {
          if (item.vehicle) {
            uniqueVehiclesMap.set(item.vehicle.id, item.vehicle);
          }
        });
        this.listVehicles = Array.from(uniqueVehiclesMap.values());
      }
    }
  }

  formatByDiscounts() {
    if (this.currentDiscounts && this.currentDiscounts.discounts) {
      this.listDiscounts = this.currentDiscounts.discounts.map(discount => ({
        [discount.discountPercentage]: this.transloco.translate('schedulingForm.corporateDiscount', { pct: discount.discountPercentage })
      }));
    }
  }

  selectPartner(event: string) {
    this.partner = event;
    this.serviceSelected = '';
    this.subServiceSelect = [];
    this.formatByServices();
  }

  selectService(event: string) {
    this.serviceSelected = event;
    this.subServiceSelect = [];
    this.formatBySubService();
  }

  selectSubService(event: string[] | string | null) {
    if (typeof event === 'string') {
      this.subServiceSelect = [event];
    } else {
      this.subServiceSelect = event || [];
    }
    this.totalPrice = this.getTotalPrice();
  }

  selectPlate(event: string | null) {
    if (event) {
      if (this.type === 'car-wash') {
        let benefit = this.currentBenefits?.benefits.find(benefit => {
          if (benefit.vehicle && benefit.vehicle.driverId) {
            return benefit.vehicle.id === event;
          }
          return false;
        });
        if (benefit) {
          this.plate = event;
        } else {
          this.plate = '';
          this.messageService.add({
            severity: 'warn',
            summary: this.transloco.translate('common.warning'),
            detail: this.transloco.translate('schedulingForm.vehicleNoDriver', { plate: this.getVehicleName(event) })
          });
        }
      } else {
        this.plate = event;
      }
    }
  }

  selectDiscount(event: string) {
    this.discountSelected = event;
    if (this.currentDiscounts && this.currentDiscounts.discounts) {
      const filteredDiscounts = this.currentDiscounts.discounts.filter(discount => (discount.discountPercentage + '') === event);

      this.filteredServicesId = Array.from(new Set(filteredDiscounts.map(discount => discount.serviceId)));
      this.filteredSubServicesId = Array.from(new Set(filteredDiscounts.map(discount => discount.subServiceId)));
      this.formatByProviders();
    }
  }

  getTotalPrice() {
    return this.getSubServiceSelected().reduce((acc, sub) => acc + sub.price, 0);
  }

  getServiceName(): string {
    const service = this.listServices?.find(service => service.id === this.serviceSelected);
    return service ? service.name : '';
  }

  getVehicleName(id?: string): string {
    const vehicle = this.listVehicles?.find(vehicle => vehicle.id === (id || this.plate));
    return vehicle ? vehicle.plate : '';
  }

  getPartnerName(): string {
    const partner = this.listPartners?.find(partner => partner.userId === this.partner);
    return partner ? partner.name : '';
  }

  claimBenefit() {
    let data: ClaimWash;
    let benefitId = this.currentBenefits?.benefits.find(benefit => {
      if (benefit.vehicle) {
        return benefit.vehicle.id === this.plate;
      }
      return false;
    })?.id;
    if (this.dateBenefit && benefitId) {
      data = {
        userProviderId: this.partner,
        datetime: this.convertToLocalISOString(this.dateBenefit),
        subServiceId: this.subServiceSelect.toString()
      };
      this.benefitsService.claimBenefit(data, this.plate, benefitId).subscribe({
        next: (res) => {
          console.log('Benefit claimed successfully:', res);
          this.statusModal = 2;
          this.txtBtn = this.transloco.translate('common.close');
        },
        error: (err) => {
          console.error('Error claiming benefit:', err);
        }
      });
    }
  }

  claimDiscount() {
    let data: ClaimDiscount;
    if (this.dateBenefit) {
      data = {
        datetime: this.convertToLocalISOString(this.dateBenefit),
        userProviderId: this.partner,
        serviceId: this.serviceSelected,
        subServiceId: this.subServiceSelect[0],
      };
      this.benefitsService.claimDiscount(data, this.plate).subscribe({
        next: (resp) => {
          console.log('Scheduling created successfully:', resp);
          this.statusModal = 2;
          this.txtBtn = this.transloco.translate('common.close');
        },
        error: (err) => {
          console.error('Error creating scheduling:', err);
        }
      });
    }
  }

  createScheduling() {
    let data: CreateScheduling;
    if (this.dateBenefit) {
      data = {
        userProviderId: this.partner,
        vehicleId: this.plate,
        serviceId: this.serviceSelected,
        subServices: this.subServiceSelect.map(sub => ({ subServiceId: sub })),
        datetime: this.convertToLocalISOString(this.dateBenefit)
      };
      this.schedulingService.createScheduling(data).subscribe({
        next: (resp) => {
          console.log('Scheduling created successfully:', resp);
          this.statusModal = 2;
          this.txtBtn = this.transloco.translate('common.close');
        },
        error: (err) => {
          console.error('Error creating scheduling:', err);
          const detail = err?.error?.error?.message || err?.error?.message || err?.message || this.transloco.translate('schedulingForm.createFailed');
          this.messageService.add({ severity: 'error', summary: this.transloco.translate('schedulingForm.scheduleErrorTitle'), detail });
        }
      });
    }
  }

  getTypeSubService() {
    if (this.type === 'car-wash' || this.type === 'discount') {
      return INPUT_TYPES.SELECT;
    }
    return INPUT_TYPES.MULTI_SELECT;
  }

  private convertToLocalISOString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}-05:00`;
  }
}
